import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { EditLicenseSystemInput, EditLicenseSystemPayload } from './generated/types';
import { GqlError } from './GqlError';

const mutation = `mutation EditLicenseSystem($input: EditLicenseSystemInput!) {
    editLicenseSystem(input: $input) {
        licenseSystemId
        succeeded
    }
}`;

export const useEditLicenseSystem = (licenseSystemId: string, orgId: string) => {
    const context = useContext(AppContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (location: string) => {

            const input: EditLicenseSystemInput = {
                licenseSystemId,
                location,
            };

            const { data } = await (context.api.graphql({
                query: mutation,
                variables: { input },
            }) as Promise<{
                data: {
                    editLicenseSystem: EditLicenseSystemPayload;
                };
                errors?: Array<GqlError>;
            }>);

            const isSucceeded = !!data.editLicenseSystem.succeeded;

            return isSucceeded;
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: ['getOrganization', orgId] });
        },
    });
};